export const ErrorService = {
    parseError(error, response = null) {
        let message = error;
        if (response && response.data) {
            message = response.data.message ? response.data.message : 'An error happened but it was not stated';
        }
        return message
    }
}